module.exports = __webpack_public_path__ + "static/img/bradesco-horizontal.a29f969.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/bradesco-horizontal.png
// module id = wMrm
// module chunks = 3